// @ts-expect-error Could not find a declaration file for module
import FeedbackLoader from 'feedback-loader';
import { useEffect, useState } from 'react';
import { UserAttributeKeys, useUserAttribute } from '../../userAttributes';
import { playlistSurveyId } from '../savedItemsConstants';
import { useIsPlaylistRoute } from '../savedItemsHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlaylistSurvey = () => {
  const isPlaylistsPath = useIsPlaylistRoute();
  const {
    userAttribute,
    userAttributeLoading,
    userAttributesError
  } = useUserAttribute(UserAttributeKeys.HAS_VIEWED_PLAYLIST);
  const [isInitialCheck, setIsInitialCheck] = useState(true);
  const [isNewPlaylistUser, setIsNewPlaylistUser] = useState(true);
  useEffect(() => {
    if (userAttributeLoading || userAttributesError) {
      return;
    }
    if (isInitialCheck) {
      setIsInitialCheck(false);
      if (userAttribute) {
        setIsNewPlaylistUser(false);
      }
    }
  }, [userAttributeLoading, userAttributesError, userAttribute, isInitialCheck]);
  if (isNewPlaylistUser || !isPlaylistsPath) {
    return null;
  }
  return /*#__PURE__*/_jsx(FeedbackLoader, {
    onClientLoad: feedbackClient => {
      feedbackClient.loadSurvey('CSAT', playlistSurveyId);
    }
  });
};